/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Sponsor_Edit_Modal_TitleInputs */



/**
* | output |
* | --- |
* | "Sponsor of {name}" |
*
* @param {Sponsor_Edit_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sponsor_edit_modal_title = /** @type {((inputs: Sponsor_Edit_Modal_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sponsor_Edit_Modal_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Parrain de ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Avalista de ${i?.name}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Padrinho de ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sponsor di ${i?.name}`)
	return /** @type {LocalizedString} */ (`Sponsor of ${i?.name}`)
});